import "./scrollable.css";

import { Page, PageHeader } from "@nike/epic-react-ui";
import { Link } from "react-router-dom";
import { Card, Text } from "@nike/eds";
import React from "react";

interface DashboardCardProps {
  path: string;
  label: string;
  number: number | string;
  numberColorClass?: string;
}

export function DashboardCard({
  path,
  label,
  number,
  numberColorClass,
}: DashboardCardProps) {
  return (
    <Link to={path}>
      <Card className="eds-elevation--3">
        <Text className="eds-spacing--mb-12" font="body-2" as="p">
          {label}
        </Text>
        <Text className={numberColorClass} font="display-2" as="p">
          {number}
        </Text>
      </Card>
    </Link>
  );
}

export function Dashboard({ history }) {
  return (
    <Page
      documentTitle="Dashboard - Customs Compliance Hub"
      width="full"
      className="scrollable"
    >
      <PageHeader
        title="Dashboard"
        summary="This dashboard provides a real-time, high-level overview of your most critical tasks and exceptions, helping you prioritize your day at a glance."
      />
      <div>
        <div className="eds-flex eds-gap--16 eds-spacing--mb-44">
          <div className="eds-flex--grow-1">
            <DashboardCard
              path="/exceptions"
              label="Tasks Due Today"
              number={5}
              numberColorClass="eds-color--blue-50"
            />
          </div>
          <div className="eds-flex--grow-1">
            <DashboardCard
              path="/exceptions"
              label="Critical Tasks (ETA 0-2 Days)"
              number={5}
              numberColorClass="eds-color--brand-orange"
            />
          </div>
          <div className="eds-flex--grow-1">
            <DashboardCard
              path="/exceptions"
              label="My Open Exceptions"
              number={5}
              numberColorClass="eds-color--brand-red"
            />
          </div>
        </div>
        <div className="eds-flex eds-gap--16">
          <div className="eds-flex--grow-1">
            <Card className="eds-elevation--3">
              <Text className="eds-spacing--mb-12" font="title-6" as="div">
                Notifications & Alerts
              </Text>
            </Card>
          </div>
        </div>
      </div>
    </Page>
  );
}
